module.exports = __webpack_public_path__ + "img/event-conference-light.c81c3923.png";